import React from 'react'

function OrgAdminEdit() {
  return (
    <div>OrgAdminEdit</div>
  )
}

export default OrgAdminEdit